import { IonContent, IonPage, } from '@ionic/react';
import React, { FormEvent } from 'react';
import styles from './css/Signup.module.css';
import Select from "react-dropdown-select";
import styled from "@emotion/styled";
import axiosInstance from '../services/AxiosInstance';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';


interface SignUpProps extends RouteComponentProps {
    // Define the props here
}

interface SignUpState {
    // Define the state here
    Organisations: Organisation[];
    SelectedValue: (string | object)[];
    Email: string;
    Achternaam: string;
    Voornaam: string;
    UserName: string;
    Password: string;
    Loading: boolean;
    LoadingOrgs: boolean;
    InviteToken: string | null;
    InviteOrganisationId: number | null;
    InviteOrganisationName: string | null;
    ShowPassword: boolean;
    RegistrationSuccess: boolean;
}

interface LBL {
    label: string,
    value: number
}


interface OrgansiationInt {
    organisationName: string,
    id: number,
    toString(): string;
}

class Organisation implements OrgansiationInt {
    organisationName: string;
    id: number;

    constructor(name: string, id: number) {
        this.organisationName = name;
        this.id = id;
    }

    toString(): string {
        return this.organisationName;
    }

}

let StyledSelect = styled(Select)`
${({ dropdownRenderer }) =>
        dropdownRenderer &&
        `
      .react-dropdown-select-dropdown {
          overflow: initial;
      }
  `}
`;

const token = localStorage.getItem("complexToken");

class SignUp extends React.Component<SignUpProps, SignUpState>
{
    firstTimeOpen: boolean;
    constructor(props: SignUpProps) {
        super(props);

        this.state = {
            Organisations: [],
            SelectedValue: [],
            Email: "",
            Achternaam: "",
            Voornaam: "",
            Loading: false,
            UserName: "",
            Password: "",
            LoadingOrgs: true,
            InviteToken: null,
            InviteOrganisationId: null,
            InviteOrganisationName: null,
            ShowPassword: false,
            RegistrationSuccess: false,
        }

        this.firstTimeOpen = true;
    }

    componentDidMount() {
        const params = new URLSearchParams(this.props.location.search);
        const invite = params.get('invite');
        if (invite) {
            this.validateInvite(invite);
        } else {
            this.GetOrganisationData();
        }
    }

    async validateInvite(token: string) {
        try {
            const res = await axiosInstance.get(`/Invites/validate/${token}`);
            this.setState({
                InviteToken: token,
                InviteOrganisationId: res.data.organisationId,
                InviteOrganisationName: res.data.organisationName,
                Email: res.data.invitedEmail || "",
                LoadingOrgs: false,
            });
        } catch {
            alert("Deze uitnodigingslink is ongeldig of verlopen.");
            this.GetOrganisationData();
        }
    }

    handleDropdownOpen = () => {
        if (this.firstTimeOpen) {
          this.firstTimeOpen = false;
          this.forceUpdate(); // Force a visual update
          console.log("updating");
        }
      }

    GetOrganisationData() {
        axiosInstance.get(`/Organisations/`, { headers: { Authorization: `Bearer ${token}` } })
            .then((res) => {
                const orgs = res.data.map((org: Organisation) => new Organisation(org.organisationName, org.id));
                this.setState({
                    Organisations: orgs,
                    LoadingOrgs: false,
                });
                StyledSelect = styled(Select)`
                    ${({ dropdownRenderer }) =>
                            dropdownRenderer &&
                            `
                        .react-dropdown-select-dropdown {
                            overflow: initial;
                        }
                    `}
                    `;
            })
            .catch((err) => {
                console.log(err);
            });
    }


    handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        this.setState({ Loading: true });
        var ok = false;

        var passwordFormat =
            /^(?=.*\d.*)(?=.*[a-z].*)(?=.*[A-Z].*)(?=.*[^a-zA-Z0-9].*).{6,}$/gm;

        let emailFormat =
            /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

        let OrgID: number;
        if (this.state.InviteOrganisationId) {
            OrgID = this.state.InviteOrganisationId;
        } else {
            let selectOrg = (this.state.SelectedValue[0] as LBL);
            OrgID = selectOrg == undefined ? 0 : selectOrg.value;
        }
        //let OrgID = 1;

        const config = {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        };

        if (OrgID < 1) {
            alert("Gelieve je organisatie aan te duiden");
            this.setState({ Loading: false });
        } else if (this.state.Email == "") {
            alert("Gelieve een emailadres in te vullen");
            this.setState({ Loading: false });
        } else if (!emailFormat.test(this.state.Email.trim())) {
            alert("Gelieve een geldig emailadres in te vullen");
            this.setState({ Loading: false });
        } else if (this.state.Password == "") {
            alert("Gelieve een wachtwoord in te vullen");
            this.setState({ Loading: false });
        } else if (!passwordFormat.test(this.state.Password)) {
            alert(
                "Het wachtwoord moet minstens: 6 tekens lang zijn, een numerieke waarde, hoofdletter, kleine letter en speciaal teken bevatten. "
            );
            this.setState({ Loading: false });
        } else if (this.state.Voornaam == "") {
            alert("Gelieve je voornaam in te vullen");
            this.setState({ Loading: false });
        } else if (this.state.Achternaam == "") {
            alert("Gelieve je familienaam in te vullen");
            this.setState({ Loading: false });
        } else {
            ok = true;
        }

        if (ok) {
            try {
                const userPayload = {
                    UserName: this.state.Email,
                    Email: this.state.Email,
                    FirstName: this.state.Voornaam,
                    LastName: this.state.Achternaam,
                    organisationId: OrgID,
                    Password: this.state.Password,
                };

                const registerEndpoint = this.state.InviteToken
                    ? "/Users/RegisterWithInvite"
                    : "/Users";

                const registerBody = this.state.InviteToken
                    ? { inviteToken: this.state.InviteToken, postUserModel: userPayload }
                    : userPayload;

                await axiosInstance.post(registerEndpoint, registerBody, config);

                axiosInstance.post("/Users/Authenticate", JSON.stringify({
                    Email: this.state.Email,
                    Password: this.state.Password,
                }), {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        "Ocp-Apim-Subscription-Key": "cd4ed8b372ef47189706abe7ae615788",
                    },
                }).then((res) => {
                    let user = res.data;
                    if (user.roles[0] == "Employee") {
                        localStorage.setItem("id", "" + user.id);
                        localStorage.setItem("userName", user.userName);
                        localStorage.setItem("token", user.jwtToken);
                        localStorage.setItem("refreshToken", user.refreshToken);
                        localStorage.setItem("organisationId", user.organisation);
                        localStorage.setItem("firstName", user.voornaam);
                        localStorage.setItem("lastName", user.familienaam);
                        localStorage.setItem("role", user.roles[0]);
                        this.goToPortal();
                    } else {
                        this.setState({ RegistrationSuccess: true });
                        setTimeout(() => { this.props.history.push("/"); }, 2500);
                    }
                }).catch(() => {
                    this.setState({ RegistrationSuccess: true });
                    setTimeout(() => { this.props.history.push("/"); }, 2500);
                });

            } catch (e: any) {
                if (e.response?.status === 409) {
                    alert("Dit e-mailadres is al in gebruik.");
                } else {
                    alert("Er ging iets fout bij het aanmaken van jouw account.");
                }
                this.setState({ Loading: false });
            }
        }
    }

    goToPortal() {
        const { history } = this.props;
        const value = localStorage.getItem('WelcomeSeen' + localStorage.getItem("id"));
        if (!value) 
        {
            history.push("/WelcomeScreen");
        }
        else
        {
            history.push("/Portal");
        }        
      }

    handleMailAddrChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ Email: event.target.value });
    };

    handleVoornaamChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ Voornaam: event.target.value });
    };

    handleAchternaamChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ Achternaam: event.target.value });
    };

    handlePwdChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ Password: event.target.value });
    };

    render() {
        const isDesktop = window.innerWidth > 768;
        const pwd = this.state.Password;
        const pwdChecks = {
            length:   pwd.length >= 6,
            number:   /\d/.test(pwd),
            upper:    /[A-Z]/.test(pwd),
            lower:    /[a-z]/.test(pwd),
            special:  /[^a-zA-Z0-9]/.test(pwd),
        };
        const checkStyle = (ok: boolean) => ({
            display: 'flex', alignItems: 'center', gap: '6px',
            color: ok ? '#90EE90' : 'rgba(255,255,255,0.6)',
            fontSize: '1.4vh', marginBottom: '2px',
        });

        if (this.state.RegistrationSuccess) {
            return (
                <IonPage ion-no-header="true">
                    <IonContent fullscreen ion-no-border="true">
                        <div style={{ backgroundImage: 'linear-gradient(#98CBFE, #339)', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                            <div style={{ fontSize: '5vh', marginBottom: '2vh' }}>✓</div>
                            <p style={{ color: 'white', fontFamily: 'Comfortaa_400Regular', fontSize: '2.5vh', textAlign: 'center', padding: '0 5vw' }}>
                                Account aangemaakt!
                            </p>
                            <p style={{ color: 'rgba(255,255,255,0.7)', fontFamily: 'Comfortaa_400Regular', fontSize: '1.8vh' }}>
                                Je wordt doorgestuurd naar de loginpagina...
                            </p>
                        </div>
                    </IonContent>
                </IonPage>
            );
        }

        return (
            <IonPage ion-no-header="true">
                <IonContent fullscreen ion-no-border="true">
                    <div style={{ backgroundImage: 'linear-gradient(#98CBFE, #339)', height: '100vh', width: '100wh', textAlign: 'center' }}>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <div style={{ marginTop: '1%', marginBottom: '-5%' }}>
                                <p className={`${styles.textFont} ${styles.headerText}`}>
                                    Registreren
                                </p>
                                <div className={(styles.logoView)}>
                                    <p className={`${styles.textFont} ${styles.logo}`}>
                                        WorkerPro
                                    </p>
                                    {isDesktop && (
                                        <p className={`${styles.textFont} ${styles.underlogo}`}>
                                            De intelligente mental wellbeing app
                                        </p>
                                    )}
                                </div>

                                {this.state.InviteOrganisationName ? (
                                    <div style={{ width: "85vw", padding: "10px", backgroundColor: "rgba(255,255,255,0.9)", borderRadius: "5px", color: "#2d5971", fontFamily: "Comfortaa_400Regular" }}>
                                        Organisatie: <strong>{this.state.InviteOrganisationName}</strong>
                                    </div>
                                ) : (
                                    <div style={{ width: "85vw", height: "auto" }}>
                                        <StyledSelect disabled={this.state.LoadingOrgs} values={[this.state.SelectedValue]} options={this.state.Organisations.map(org => ({ value: org.id, label: org.toString() }))}
                                        onChange={(value: (string | object)[]): void => {
                                            this.setState({ SelectedValue: value as (string | object)[] });
                                        }}
                                        style={{
                                            borderWidth: "1px",
                                            borderColor: "rgba(52, 52, 52, 0.0)",
                                            backgroundColor: "rgba(255, 255, 255, 1.0)",
                                            color: "black",
                                            fontFamily: "Comfortaa_400Regular",
                                            fontSize: "4vh",
                                            borderRadius: "5px",
                                            textOverflow: "ellipsis",
                                        }}
                                        onDropdownOpen={this.handleDropdownOpen}
                                        placeholder='Selecteer een onderneming...'
                                        />
                                    </div>
                                )}

                                <form onSubmit={this.handleSubmit}>
                                    <div className={styles.inputView}>
                                        <input name='MailAddr' className={styles.inputText} placeholder='E-mailadres' onChange={this.handleMailAddrChange} value={this.state.Email}></input>
                                    </div>
                                    <div className={styles.inputView}>
                                        <input name='Voornaam' className={styles.inputText} placeholder='Voornaam' onChange={this.handleVoornaamChange} value={this.state.Voornaam}></input>
                                    </div>
                                    <div className={styles.inputView}>
                                        <input name='Acthernaam' className={styles.inputText} placeholder='Familienaam' onChange={this.handleAchternaamChange} value={this.state.Achternaam}></input>
                                    </div>
                                    <div className={styles.inputView}>
                                        <div style={{ position: 'relative', display: 'inline-block', width: '80vw' }}>
                                            <input
                                                name='Password'
                                                className={styles.inputPwd}
                                                type={this.state.ShowPassword ? 'text' : 'password'}
                                                placeholder='Wachtwoord'
                                                value={this.state.Password}
                                                onChange={this.handlePwdChange}
                                                style={{ width: '100%', paddingRight: '2.8rem', boxSizing: 'border-box' }}
                                            />
                                            <button
                                                type="button"
                                                onClick={() => this.setState({ ShowPassword: !this.state.ShowPassword })}
                                                style={{ position: 'absolute', right: '0.4rem', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', padding: '0', lineHeight: '1', display: 'flex', alignItems: 'center' }}
                                            >
                                                {this.state.ShowPassword ? (
                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                                                        <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                                                        <line x1="1" y1="1" x2="23" y2="23"/>
                                                    </svg>
                                                ) : (
                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                                                        <circle cx="12" cy="12" r="3"/>
                                                    </svg>
                                                )}
                                            </button>
                                        </div>
                                        {this.state.Password.length > 0 && (
                                            <div style={{ textAlign: 'left', marginTop: '8px' }}>
                                                <div style={checkStyle(pwdChecks.length)}>
                                                    {pwdChecks.length ? '✓' : '○'} Minstens 6 tekens
                                                </div>
                                                <div style={checkStyle(pwdChecks.number)}>
                                                    {pwdChecks.number ? '✓' : '○'} Een cijfer
                                                </div>
                                                <div style={checkStyle(pwdChecks.upper)}>
                                                    {pwdChecks.upper ? '✓' : '○'} Een hoofdletter
                                                </div>
                                                <div style={checkStyle(pwdChecks.lower)}>
                                                    {pwdChecks.lower ? '✓' : '○'} Een kleine letter
                                                </div>
                                                <div style={checkStyle(pwdChecks.special)}>
                                                    {pwdChecks.special ? '✓' : '○'} Een speciaal teken
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div style={{ marginTop: "5vh" }}>
                                        <button disabled={this.state.Loading} className={(`${styles.button} ${styles.buttonText}`)} type='submit'>Registreren</button>
                                    </div>
                                </form>
                                <p className={`${styles.textFont} ${styles.info}`} style={{ marginBottom: "0px", marginTop: "2vh", fontSize: 10 }}>
                                    Door op registreren te klikken ga je accoord met onze <Link className={(styles.textFont)} style={{ fontSize: 10, color: "#FFF" }} to="/privacy"> Privacy Policy</Link>
                                </p>
                                <p className={`${styles.textFont} ${styles.info}`} style={{ marginBottom: "0px", fontSize: 10 }}>
                                    Al een account? <Link className={(styles.textFont)} style={{ fontSize: 10, color: "#FFF" }} to="/"> Inloggen</Link>
                                </p>
                            </div>
                        </div>
                    </div>
                </IonContent>
            </IonPage>
        )
    };
}

export default withRouter(SignUp)
